import { useState } from "react";
import { useDispatch } from "react-redux";

import { deleteAssignedWorksheetList } from "../../assignedWorksheetListSlice";
import { deleteAssignmentList } from "../../assignmentListSlice";

import { Button } from "../../../../components/Button";

const DeleteWorksheetModal = ({ worksheets, setSelectedWorksheets, type }) => {
  const dispatch = useDispatch();

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleDeleteClick = () => {
    setIsDeleteModalOpen(true);
  };

  const confirmDelete = () => {
    if (type === "assigned") {
      dispatch(
        deleteAssignedWorksheetList({
          worksheetIds: worksheets.map((worksheet) => worksheet.id),
        })
      );
    } else {
      // For retry assignments, use the same deletion as regular assignments
      dispatch(
        deleteAssignmentList({
          assignmentIds: worksheets.map((worksheet) => worksheet.id),
        })
      );
    }
    setIsDeleteModalOpen(false);
    setSelectedWorksheets([]);
  };

  // [추가] 삭제 모달 닫기
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const styles = {
    overlayStyle: {
      position: "fixed",
      bottom: 0,
      left: 0,
      width: "100%",
      backgroundColor: "#2D2D2D",
      color: "#fff",
      padding: "20px",
      textAlign: "center",
      zIndex: 9999,
    },
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      color: "#000",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    },
    modalContent: {
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "8px",
      width: "300px",
      maxWidth: "90%",
    },
    modalHeader: {
      textAlign: "center",
      fontSize: "16px",
      marginBottom: "40px",
    },
    modalBody: {
      marginBottom: "40px",
      lineHeight: "1.0",
    },
    modalFooter: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    dangerButton: {
      backgroundColor: "#FF4444",
      color: "#fff",
      border: "none",
      padding: "6px 12px",
      width: "100%",
      cursor: "pointer",
      borderRadius: "4px",
    },
    cancelButton: {
      backgroundColor: "#EBEBEB",
      color: "#737373",
      border: "none",
      padding: "6px 12px",
      cursor: "pointer",
      width: "100%",
      borderRadius: "4px",
    },
  };

  return (
    <div style={styles.overlayStyle}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "70%",
          margin: "0 auto",
        }}
      >
        <strong>문제지 {worksheets.length}명 선택됨</strong>
        <div>
          <Button
            backgroundColor="#FFFFFF"
            color="#FF4444"
            border="1px solid #EBEBEB"
            fontSize="16px"
            padding="10px 35px"
            onClick={() => handleDeleteClick()}
          >
            삭제하기
          </Button>

          {isDeleteModalOpen && (
            <div style={styles.modalOverlay} onClick={closeDeleteModal}>
              <div
                style={styles.modalContent}
                onClick={(e) => e.stopPropagation()}
              >
                <div style={styles.modalHeader}>학생 삭제</div>
                <div style={styles.modalBody}>
                  <strong style={{ textAlign: "center" }}>
                    {worksheets[0].title}를 포함한 {worksheets.length}개의
                  </strong>
                  <p>
                    <strong style={{ textAlign: "center" }}>
                      과제를 정말 삭제하시겠습니까?
                    </strong>
                  </p>
                </div>
                <div style={styles.modalFooter}>
                  <button style={styles.dangerButton} onClick={confirmDelete}>
                    네
                  </button>
                  <button
                    style={styles.cancelButton}
                    onClick={closeDeleteModal}
                  >
                    아니오
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeleteWorksheetModal;
